export const FILE_IDS = ['fileIds'];
export const FILE_USAGE_TYPES = ['fileUsageTypes'];
export const FILE_SENSITIVITY_EXEMPTION = ['fileSensitivityExemption'];